import { ColorOptions } from '@jfs/ui-new/src/theme/UiThemeProvider'
import { FC, useContext } from 'react';
import { ActivityIndicator } from 'react-native'
import { ThemeContext } from 'styled-components/native'
const LoaderType = {
  small: 'small',
  large: 'large',
}

export type LoaderTypeOptions = keyof typeof LoaderType
export const LoaderTypeOptionArray = Object.keys(LoaderType)

export interface LoaderProps {
  type?: keyof typeof LoaderType | number | Array<keyof typeof LoaderType>
  color?: ColorOptions | Array<ColorOptions>
}

export const LoaderNew: FC<LoaderProps> = (props) => {
  const { type = 'small', color = 'PRIMARY' } = props
  let selectionColor: any = color
  const theme = useContext(ThemeContext)
  if (selectionColor && theme?.colors[selectionColor as ColorOptions]) {
    selectionColor = theme?.colors[selectionColor as ColorOptions]
  }
  return <ActivityIndicator size={type as keyof typeof LoaderType} color={selectionColor} />
}
